<div class="position-fixed vh-100-h w-100" (click)="closeModal()">
  <div class="container-fluid">
    <div class="row">
      <div  class="bg-white custom-modal border br-24 p-3 pt-4 col-lg-6 col-xl-5 offset-xl-1 position-relative d-flex flex-column" (click)="$event.stopPropagation()">
        <span class="material-icons-outlined ms-auto lightGray2 pointer position-absolute" (click)="closeModal()">close</span>
        <div id="scroll_listener" class="hidden-scrollbar overflow-auto px-2 pb-3">

          <!--    HEADER : image, name, price, address -->
          <div class="custom-grid mb-3">
            <div class="custom-box_img lf-after-bg pt-3 position-relative pointer" (click)="openModal(photoModal)">
              <button class="btn btn-yellow position-absolute border-0 br-8 d-flex align-items-center justify-content-center py-2 px-2"
                      (click)="$event.stopPropagation(); addToFavorites(room.id)" *ngIf="favList">
                <i [ngClass]="isFavorite(room.id)" class="fa fa-heart font-20"></i>
              </button>
              <button class="btn btn-yellow position-absolute border-0 br-8 text-white font-12 py-2 text-nowrap" >
                {{ 'COMMON.MORE_PICTURES' | translate }}
                <span class="material-icons-outlined font-12 v-middle">keyboard_arrow_right</span>
              </button>
              <img checkurl [src]="room.cover_photo" alt="" class="w-100 h-100 img-cover br-24">
            </div>

            <div class="custom-box_name d-flex flex-column justify-content-center justify-content-xl-start position-relative pt-4 text-break">
              <h1 class="font-trueno-bold font-28 txt-darkGray mb-1">{{ roomNameSplitted[0].trim() }}</h1>
              <h6 class="fw-normal font-18 txt-darkGray mb-1">{{ roomNameSplitted[1]?.trim() }}</h6>
              <h2 class="font-16 mediumGray fw-lighter text-break">
                {{ room.property_address.city }} ({{room.property_address.postal_code}}), {{ room.property_address.state }}
              </h2>
            </div>

            <div class="custom-box_info">
              <div class="border br-8 text-center font-12 mediumGray py-1 bg-room">
                <span class="material-icons font-16 txt-darkGray me-1 v-middle">groups</span>
                <div *ngIf="room.partner_type === 'room'">{{ 'REGISTRATION.HOUSING_TYPE.FLATSHARING.TITLE' | translate }}</div>
                <div *ngIf="room.partner_type !== 'room'">{{ 'REGISTRATION.HOUSING_TYPE.STUDIO.TITLE' | translate }}</div>
                
              </div>
                <app-accom-roomspec [room]="room"></app-accom-roomspec>
            </div>

            <div class="custom-box_price text-center mt-3">
              <h1 class="font-trueno-bold font-28 txt-dark-blue text-nowrap mb-0">{{room.price}} <span class="font-20">{{ 'REGISTRATION.HOUSING_BUDGET.COST_LABEL' | translate }}</span></h1>
              <p class="lightGray2 font-12 text-nowrap">{{ 'PROCESSES.ACCOMMODATION.RESERVATION.MIN' | translate:{value: room.minimal_stay_duration ? room.minimal_stay_duration : '90'} }}</p>
            </div>
          </div>

          <!--    TAB : resume, characteristics, charges      -->
          <mat-tab-group #matTabGroup animationDuration="0ms" class="far-border lf-tab sticky-top bg-white" (selectedIndexChange)="tabChanges($event)">
            <mat-tab label="{{ 'PROCESSES.ACCOMMODATION.LIST.SUMMARY' | translate }}"></mat-tab>
            <mat-tab label="{{ 'PROCESSES.ACCOMMODATION.ROOM.ADVANTAGES' | translate }}"></mat-tab>
            <mat-tab label="{{ 'PROCESSES.ACCOMMODATION.LIST.PRICE_INFORMATIONS' | translate }}"></mat-tab>
            <mat-tab label="{{ 'PROCESSES.ACCOMMODATION.LIST.CHARAC' | translate }}"></mat-tab>
            <mat-tab label="{{ 'PROCESSES.ACCOMMODATION.LIST.RENTAL_CHARGES' | translate }} ({{ 'PROCESSES.ACCOMMODATION.CHARGES.PROVISIONS_ON_COSTS' | translate }})"></mat-tab>
            <mat-tab label="{{ 'PROCESSES.ACCOMMODATION.LIST.AROUND' | translate }}"></mat-tab>
            <mat-tab label="{{ 'COMMON.FAQ' | translate }}"></mat-tab>
          </mat-tab-group>

          <div id="resume" class="pt-3 d-flex flex-column">
            <p class="overflow-hidden ellipsis_multiline" [ngClass]="{'show-content': showSummary}" [innerHTML]="locale === 'fr' ? room.property_description?.summary_fr : room.property_description?.summary"></p>
            <button class="btn border-0 lightGray2 font-14 ms-auto transition-0" (click)="showSummary = !showSummary">{{ (showSummary ? 'COMMON.SHOW.LESS' : 'COMMON.SHOW.MORE') | translate }}</button>
          </div>

          <app-accommodation-features [room]="room" [type]="'advantages'" [isLoading]="isLoadingAmenities"></app-accommodation-features>
          <app-accommodation-price-box [room]="room"></app-accommodation-price-box>
          <app-accommodation-features [amenities_1]="amenities_1" [amenities_2]="amenities_2" [type]="'features'" [isLoading]="isLoadingAmenities"  [room]="room"></app-accommodation-features>
          <app-accommodation-features [type]="'charges'" [room]="room" [isLoading]="isLoadingAmenities"></app-accommodation-features >


          <mat-accordion id="around" class="info-accordion">
            <mat-expansion-panel expanded>
              <mat-expansion-panel-header class="ps-0">
                <mat-panel-title class="font-16 lf-font txt-darkGray">{{ "PROCESSES.ACCOMMODATION.LIST.AROUND" | translate }}</mat-panel-title>
              </mat-expansion-panel-header>
              <div class="map_box br-24 overflow-hidden mb-4">
                <google-map width="100%" height="100%" [zoom]="zoom" [center]="center" [options]="options">
                  <map-marker *ngIf="roomMarker" [position]="roomMarker.position" [options]="roomMarker.options"></map-marker>
                </google-map>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <!--    ROOM FAQ      -->
          <app-faq-accordion [faqFields]="detailFaq"></app-faq-accordion>
        </div>
        <div class="pt-3 bg-white" *ngIf="isReselectRoom">
          <button class="btn btn-primary fw-bold text-white w-100 font-20 py-3" (click)="changeRoom(room)">
            <span class="material-icons-outlined va-sub me-2">history_edu</span>
            {{ "PROCESSES.ACCOMMODATION.BOOK.RESERVATION" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- PHOTO MODAL -->
<ng-template #photoModal>
  <app-slider [hasTitle]="false" [mode]="'modal'" [items]="propertyPhotos" [isInfiniteLoop]="true" buttonPosition="mid-left_right"></app-slider>
</ng-template>


<!-- TOO MANY FAV MODAL -->
<app-component-modal-favorite [favList]="favList" *ngIf="showFavErrorModal"
                              (isModalClosed)="showFavErrorModal = $event"></app-component-modal-favorite>
